import React from 'react'
import 'styles/UserContent.css'

export default function UserContent (props) {
  return <div className='UserContent' {...props} />
}
